<template>
    <div class="knowledge">
        <div class="banner"></div>

        <div class="know-body">
            <Breadcrumb  class="bread" separator=">">
                <BreadcrumbItem to="/">
                    <img class="bread-icon" src="../assets/images/icon-location.png"/>首页
                </BreadcrumbItem>
                <BreadcrumbItem class="bread-last">公司见闻</BreadcrumbItem>
            </Breadcrumb>
            <router-link target="_blank" :to="{name: 'CorporateKnowledgeDetail',params:{ id: l.id} }" v-for="(l,index) in list" :key="index">
                <div v-if="l.list_img == null" class="list-noimg">
                    <div class="know-title">
                        <h5 class="title-info">{{l.title}} <span :style="{ background: l.color }" class="title-state">{{ l.tag_name }}</span></h5>
                        <span class="know-time">{{l.created_at | formatDate}}</span>
                    </div>
                    <div class="know-short">
                        <p class="msg">{{l.news_describe}}</p>
                    </div>
                </div>
                <div v-else class="list-img">
                    <img class="img-cover" :src="baseURL + l.list_img" alt="">
                    <div class="img-info">
                        <div class="know-title">
                            <h5 class="title-info">{{l.title}}<span :style="{ background: l.color }" class="title-state">{{ l.tag_name }}</span></h5>
                            <span class="know-time">{{l.created_at  | formatDate}}</span>
                        </div>
                        <p>{{l.news_describe}}</p>
                    </div>

                </div>
            </router-link>
            <div class="page-box text-center">
                <Page class-name="pages" :total="total" prev-text="上一页" next-text="下一页" show-elevator show-total :page-size="15" @on-change="changePage"/>
            </div>
        </div>
    </div>
</template>
<script>
import * as apis from "@/api/other.js"
import {baseURL} from "@/api/axios"
export default {
    data(){
        return {
            baseURL: baseURL + 'storage/',
            total: 0,
            list: [

            ]
        }
    },
    filters: {
        formatDate: function(val){
            let res = val.substr(0,10);
            return res;
        }
    },
    mounted(){
        this.getAllNews(1);
    },
    methods: {
        async getAllNews(page){
            try{
                let data = {
                    page: page
                };
                let res = await apis.getCorperateKnowledge(data);
                if(res.code == 200){
                    this.list = res.data.data;
                    this.total = res.data.total;
                }
            }catch(e){
                console.log(e)
            }
        },
        changePage(index){
            this.getAllNews(index);
            window.scrollTo(0,0);
        }
    }
}
</script>
<style lang="less" scoped>
.knowledge{
    background: #fff;
    overflow: hidden;
}
.banner{
    height: 250px;
    background: url("../assets/images/knowledge/banner.jpg") no-repeat center;
}
.know-body{
    width: 970px;
    margin: 0 auto;
}
.bread{
    margin: 30px 0 0;
}
.know-title{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .title-info{
            font-size: 24px;
            color: #333130;
            line-height: 44px;
            font-weight: normal;
            .title-state{
                display: inline-block;
                width: 88px;
                text-align: center;
                background: #ae1e10;
                color: #fff;
                font-size: 14px;
                line-height: 26px;
                vertical-align: text-bottom;
                padding: 0 14px;
                margin-left: 10px;
            }
        }
        .know-time{
            font-size: 20px;
            color: #333130;
            line-height: 44px;
        }
    }
.list-noimg{
    border-bottom: 1px solid #dddddd;
    padding: 40px 0 20px;

    .know-short{
        .msg{
            font-size: 20px;
            color: #898888;
            line-height: 40px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
.list-img{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 60px 0 48px;
    border-bottom: 1px solid #eee;
    .img-cover{
        width: 240px;
        height: 210px;
        margin-right: 25px;
    }
    .img-info{
        flex: 1;
        p{
            font-size: 20px;
            color: #898888;
            line-height: 40px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
        }
    }
}
.page-box{
    margin: 100px 0;
}
</style>
